import React from 'react';
import { DashboardLayout, DashboardOverview } from '../components/dashboard';

export const DashboardPage: React.FC = () => {
  return (
    <DashboardLayout>
      <DashboardOverview />
    </DashboardLayout>
  );
};